import { History } from "history";
import { analytics } from "MVVM/Analytics";
import { readOnboardingVariant } from "MVVM/Hooks/useOnboardingVariant";
import {
  SIGNUP_PLAN_EXPERIMENT,
  SIGNUP_PLAN_PATH,
  takeSignupPlan,
} from "MVVM/State/signupPlanExperiment";

export const redirectToSignupPlan = (
  history: History,
  userId: string | undefined,
  destination: string,
): boolean => {
  const signup = takeSignupPlan(userId);
  if (!signup) return false;
  analytics.track("Signup Plans - Offered", {
    experiment: SIGNUP_PLAN_EXPERIMENT,
    signup_plan_variant: signup.variant,
    account_id: userId,
    signup_provider: signup.provider,
    onboarding_variant: readOnboardingVariant(userId),
    forced: signup.forced,
  });
  history.push(SIGNUP_PLAN_PATH, { signupPlan: { ...signup, destination } });
  return true;
};
